import Vue from 'vue'
import Router from 'vue-router'
import {Message} from 'element-ui'
//引入组件
import Home from '@/page/home'
import UserInfo from '@/page/officialEmail/info/UserInfo'
import OfficialEmail from '@/page/officialEmail/reg'
import CheckPhone from '@/page/officialEmail/checkPhone'
import UpdatePhone from '@/page/officialEmail/updatePhone'
import CheckIdentity from '@/page/officialEmail/checkIdentity'
import QrCode from '@/page/officialEmail/qrcode'
import RedirectUrl from '@/page/Coremail/redirectUrl'
import ChoseType from '@/page/Coremail/choseType'
import Coremail from '@/page/Coremail/reg'
import BindCoremail from '@/page/Coremail/bind'
import BlockCoremail from '@/page/Coremail/block'
import ForgetPwd from '@/page/reSetPwd'
import Step1 from '@/page/reSetPwd/step1'
import Step2 from '@/page/reSetPwd/step2'
import Step3 from '@/page/reSetPwd/step3'
import Step4 from '@/page/reSetPwd/step4'
import Maintain from '@/page/maintain'

Vue.use(Router)

const router =  new Router({
  mode:'history', // 路径中去掉#号
  routes: [
        {
      path: '/',
      redirect:'/homePage'
    },
    {
      path: '/homePage',
      name: 'Home',
      component: Home,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },
    {
      path: '/maintain',
      name: 'Maintain',
      component: Maintain,
      meta:{
        requireLogin:false
      }
    },
    {
      path: '/regOfficialEmail/userInfo',
      name: 'UserInfo',
      component: UserInfo,
      meta:{
        requireLogin:true
      },
      // redirect:'/maintain'
    },
    {
      path: '/regOfficialEmail/checkPhone',
      name: 'checkPhone',
      component: CheckPhone,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },
    {
      path: '/regOfficialEmail/updatePhone',
      name: 'UpdatePhone',
      component: UpdatePhone,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },
    {
      path: '/regOfficialEmail/checkIdentity',
      name: 'CheckIdentity',
      component: CheckIdentity,
      meta:{
        requireLogin:true
      },
      // redirect:'/maintain'
    },
    {
      path: '/regOfficialEmail/qrcode',
      name: 'QrCode',
      component: QrCode,
      meta:{
        requireLogin:true
      },
      // redirect:'/maintain'
    },

    {
      path: '/regOfficialEmail/form',
      name: 'RegOfficialEmail',
      component: OfficialEmail,
      meta:{
        requireLogin:true
      },
      // redirect:'/maintain'
    },
    {
      path: '/regCoremail/redirectUrl',
      name: 'RedirectUrl',
      component: RedirectUrl,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },
    {
      path: '/regCoremail/choseType',
      name: 'ChoseType',
      component: ChoseType,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },
    {
      path: '/regCoremail/form',
      name: 'RegCoremail',
      component: Coremail,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },
    {
      path: '/regCoremail/bind',
      name: 'BindCoremail',
      component: BindCoremail,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },
    {
      path: '/regCoremail/block',
      name: 'BlockCoremail',
      component: BlockCoremail,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },

    {
      path: '/forgetPwd',
      name: 'ForgetPwd',
      component: ForgetPwd,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },
    {
      path: '/forgetPwd/step1',
      name: 'Step1',
      component: Step1,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },
    {
      path: '/forgetPwd/step2',
      name: 'Step2',
      component: Step2,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },
    {
      path: '/forgetPwd/step3',
      name: 'Step3',
      component: Step3,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },
    {
      path: '/forgetPwd/step4',
      name: 'Step4',
      component: Step4,
      meta:{
        requireLogin:false
      },
      // redirect:'/maintain'
    },

  ]
})

// 路由拦截
// 差点忘了说明,不是所有版块都需要鉴权的
// 所以需要鉴权,我都会在路由meta添加添加一个字段requireLogin,设置为true的时候
// 这货就必须走鉴权,像登录页这些不要,是可以直接访问的!!!

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireLogin)) {
    // 判断是否需要验证身份
    const token = sessionStorage.getItem("officeEmail_token")
    if (token) {
      // 判断是否验证
        if (token.length == 32) {
          next();
        } else {
          Message({
            showClose: true,
            message: "验证身份信息已过期,请重新验证",
            type: "error"
          });
          next({
            path: "/homePage"
          });
        }
    } else {
      // 没验证则跳转到验证身份页面
      Message({
        showClose: true,
        message: "验证身份信息已过期,请重新验证",
        type: "error"
      });
      next({
        path: "/homePage"
      });
    }
  }else{
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js